import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import Carousel from 're-carousel';
import IndicatorDots from '../../components/signup-ads-instagram-carousel-indicators/component'
import {cartRegister} from "../../services/cartRegister";
import {flowRegister} from "../../services/flowRegister";
import queryString from "query-string";
import {imagesRegister} from "../../services/imagesRegister";
import {themeRegister} from "../../services/themeRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";
import {userRegister} from "../../services/userRegister";
import {agentRegister} from "../../services/agentRegister";
import {langRegister} from "../../services/langRegister";
import {collectedRegister} from "../../services/collectedRegister";

class SignupAdsInstagramCarousel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: [],
            query: null,
            theme: null
        };
    };

    componentWillMount() {
        this.init.data();
        this.init.slides();
    }

    init = {
        data: () => {

            if (collectedRegister.getValue("custom_creative")) {

                let data_custom_creative = {};

                let data = themeRegister.getValue();
                let theme = themeRegister.getTheme();

                let theme_data = themeRegister.getValue();
                if(theme_data && theme_data.theme_region){
                    if (langRegister.lang() === "sv") {
                        data_custom_creative.agent_description = "Expert på " + theme_data.theme_region;
                    } else {
                        data_custom_creative.agent_description = theme_data.theme_region + " Expert";
                    }
                }

                let user_data = userRegister.getUser();
                let agent_data = agentRegister.get();
                if(user_data && user_data.branding_pref){
                    data_custom_creative.branding_image = user_data.branding_image;
                }

                try {

                    data_custom_creative.type = JSON.parse(collectedRegister.getValue("type")).title;
                    //TODO: type_default only tested in EN and SE lang, other langs need to be tested
                    data_custom_creative.type_default = JSON.parse(collectedRegister.getValue("type")).title + " " + collectedRegister.getValue("offering");
                    data_custom_creative.offering = collectedRegister.getValue("offering");

                    if (theme === "promotion") {
                        data_custom_creative.slogan = theme_data.slogan_offer;
                    } else {
                        data_custom_creative.slogan = theme_data.slogan_validation;
                    }

                    if (collectedRegister.getValue("listing_type").indentifier === "sale") {
                        data_custom_creative.slogan_offering = JSON.parse(collectedRegister.getValue("status")).title;
                    } else {
                        data_custom_creative.slogan_offering = JSON.parse(collectedRegister.getValue("furnishings")).title;
                    }

                    data_custom_creative.slogan_promo = theme_data.slogan_offer;
                    data_custom_creative.slogan_calltoaction = theme_data.last_subtitle;

                    data_custom_creative.area = theme_data.theme_region;
                    data_custom_creative.building = collectedRegister.getValue("google").autocomplete_address;
                    data_custom_creative.city = collectedRegister.getValue("display_region").name;

                    data_custom_creative.size = collectedRegister.getValue("size_custom");
                    data_custom_creative.beds = JSON.parse(collectedRegister.getValue("bed")).title;
                    data_custom_creative.baths = JSON.parse(collectedRegister.getValue("bath")).title;
                    data_custom_creative.price = theme_data.last_title;

                } catch (e) {}

                try {
                    if (collectedRegister.getValue("contact").permit) {
                        data_custom_creative.permit = collectedRegister.getValue("contact").permit ? collectedRegister.getValue("contact").permit : ""
                    }
                } catch (e) {}

                try {
                    if (collectedRegister.getValue("qrcode_ads")) {
                        data_custom_creative.qrcode = collectedRegister.getValue("contact").qrcode ? collectedRegister.getValue("contact").qrcode : ""
                    }
                } catch (e) {}

                if(agent_data && agent_data.profile_image){
                    if(agent_data && agent_data.profile_image){
                        data_custom_creative.agent_image = agent_data.profile_image;
                    }
                    if(agent_data && agent_data.name){
                        data_custom_creative.agent_name = agent_data.name;
                    }
                }else{
                    if(user_data && user_data.profile_image){
                        data_custom_creative.agent_image = user_data.profile_image;
                    }
                    if(user_data && user_data.logo_image){
                        data_custom_creative.agency_image = user_data.logo_image;
                    }
                    if(user_data && user_data.name){
                        data_custom_creative.agent_name = user_data.name;
                    }
                }

                data_custom_creative.first_image = theme_data.first_image;

                try {
                    if (collectedRegister.getValue("contact").permit) {
                        data.permit = collectedRegister.getValue("contact").permit ? collectedRegister.getValue("contact").permit : ""
                    }
                } catch (e) {}

                try {
                    if (collectedRegister.getValue("qrcode_ads")) {
                        data.qrcode = collectedRegister.getValue("contact").qrcode ? collectedRegister.getValue("contact").qrcode : ""
                    }
                } catch (e) {}

                let query = queryString.stringify(data_custom_creative);
                this.setState({
                    data: data,
                    theme: theme,
                    query: query,
                    //type: type,
                    //extra_image: extra_image
                })

            } else {

                let data = themeRegister.getValue();
                let theme = themeRegister.getTheme();

                let theme_data = themeRegister.getValue();
                if(theme_data && theme_data.theme_region){
                    if (langRegister.lang() === "sv") {
                        data.agent_description = "Expert på " + theme_data.theme_region;
                    } else {
                        data.agent_description = theme_data.theme_region + " Expert";
                    }
                }

                let user_data = userRegister.getUser();
                let agent_data = agentRegister.get();
                console.log(user_data);

                if(user_data && user_data.branding_pref){
                    data.primary_color = user_data.branding_pref.primary_color;
                    data.secondary_color = user_data.branding_pref.secondary_color;
                    data.branding_image = user_data.branding_image;
                }

                try {
                    if(user_data && user_data.branding_pref){
                        data.disable_infobox = user_data.branding_pref.disable_infobox ? user_data.branding_pref.disable_infobox : false;
                        data.infobox_m = user_data.branding_pref.infobox_m ? user_data.branding_pref.infobox_m : false;
                        data.infobox_s = user_data.branding_pref.infobox_s ? user_data.branding_pref.infobox_s : false;
                        data.opacity_infobox = user_data.branding_pref.opacity_infobox ? user_data.branding_pref.opacity_infobox : false;
                    }
                } catch (e) {}

                if(user_data && user_data.logo_image){
                    data.agency_image = user_data.logo_image;
                }
                if(!data.agent_description && user_data.company_name){
                    data.agent_description = user_data.company_name;
                }
                if(!data.agent_description && user_data.billing_company){
                    data.agent_description = user_data.billing_company;
                }

                if(agent_data && agent_data.profile_image){
                    if(agent_data && agent_data.profile_image){
                        data.agent_image = agent_data.profile_image;
                    }
                    if(agent_data && agent_data.email){
                        try{
                            let split_email = agent_data.email.split("@");
                            if(Array.isArray(split_email) && split_email.length > 1){
                                data.agency_website = split_email[1];
                            }
                        }catch (e) {}
                    }
                    if(agent_data && agent_data.name){
                        data.agent_name = agent_data.name;
                    }
                    if (user_data.fallback_pref && user_data.fallback_pref.phone) {
                        data.agent_phone = user_data.phone;
                    } else {
                        if (agent_data && agent_data.phone) {
                            data.agent_phone = agent_data.phone;
                        }
                    }
                }else{
                    if(user_data && user_data.profile_image){
                        data.agent_image = user_data.profile_image;
                    }
                    if(user_data && user_data.logo_image){
                        data.agency_image = user_data.logo_image;
                    }
                    if(user_data && user_data.email){
                        try{
                            let split_email = user_data.email.split("@");
                            if(Array.isArray(split_email) && split_email.length > 1){
                                data.agency_website = split_email[1];
                            }
                        }catch (e) {}
                    }
                    if(user_data && user_data.name){
                        data.agent_name = user_data.name;
                    }
                    if(user_data && user_data.phone){
                        data.agent_phone = user_data.phone;
                    }
                }

                /*
                let type = themeRegister.getThemeType();
                let extra_image = "";
                if(type !== "no_theme" && data){
                    let user_data = userRegister.getUser();
                    if(type === "agent_theme" && user_data && user_data.profile_image){
                        data.theme_type = type;
                        extra_image = user_data.profile_image;
                    }
                    if(type === "agency_theme" && user_data && user_data.logo_image){
                        data.theme_type = type;
                        extra_image = user_data.logo_image;
                    }
                }
                 */

                if(theme === "broker"){
                    data.slogan_validation = data.last_title;
                }

                try {
                    if (collectedRegister.getValue("contact").permit) {
                        data.permit = collectedRegister.getValue("contact").permit ? collectedRegister.getValue("contact").permit : ""
                    }
                } catch (e) {}

                try {
                    if (collectedRegister.getValue("qrcode_ads")) {
                        data.qrcode = collectedRegister.getValue("contact").qrcode ? collectedRegister.getValue("contact").qrcode : ""
                    }
                } catch (e) {}

                let query = queryString.stringify(data);
                this.setState({
                    data: data,
                    theme: theme,
                    query: query,
                    //type: type,
                    //extra_image: extra_image
                }, () => {
                    console.log(this.state.query);
                })
            }
        },
        slides: () => {

            let user_data = userRegister.getUser();
            let images = imagesRegister.get();
            let mainImage = imagesRegister.getMain();
            let mainImageTitle = flowRegister.getValue("main_image_title");
            let items = Array.isArray(flowRegister.getValue("video_items"))?flowRegister.getValue("video_items"):[];
            let location = flowRegister.getValue("display_region");
            let industry = cartRegister.get().industry.name;
            let slides = [];
            let custom_slides = [];

            try{
                let cart = cartRegister.get();
                if(cart.admin_slideshow_images){
                    custom_slides = cart.admin_slideshow_images.filter((item) => {
                        try{
                            return item.images.small && item.selected;
                        }catch (e) {
                            return false
                        }
                    }).sort((a, b) => (a.number > b.number) ? 1 : -1).map((item) => {
                        return item.images.small;
                    });
                }
            }catch (e) {}

            if(mainImage && custom_slides.length < 1){
                let slide = {
                    image: mainImage.images.small,
                    image_title: mainImageTitle,
                    title: mainImageTitle,
                    description: industry + " | " + location
                };
                if(user_data && user_data.branding_pref){
                    if(user_data.branding_pref.primary_color){
                        slide.primary_color = user_data.branding_pref.primary_color.replace('#', '');
                    }
                    if(user_data.branding_pref.secondary_color){
                        slide.secondary_color = user_data.branding_pref.secondary_color.replace('#', '');
                    }
                    if(user_data.branding_image){
                        slide.branding_image = user_data.branding_image;
                    }
                }
                try {
                    if(user_data && user_data.branding_pref){
                        slide.infobox_m = user_data.branding_pref.infobox_m ? user_data.branding_pref.infobox_m : false;
                        slide.infobox_s = user_data.branding_pref.infobox_s ? user_data.branding_pref.infobox_s : false;
                    }
                } catch (e) {}
                slides.push(slide);
            }

            if(custom_slides.length > 0){
                for(let i = 0; i < custom_slides.length; i++) {
                    if (slides.length < 10) {
                        let slide = {
                            image: custom_slides[i],
                            image_title: null,
                            title: industry,
                            description: location
                        };

                        for(let m = 0; m < items.length; m++){
                            if(!items[m].used && !slide.image_title){
                                slide.image_title = items[m].title;
                                items[m].used = true;
                                break;
                            }
                        }
                        if(!slide.image_title){
                            for(let m = 0; m < items.length; m++){
                                if(!items[m].used && (!items[m].label && items[m].label !== 0)){
                                    slide.image_title = items[m].title;
                                    items[m].used = true;
                                    break;
                                }
                            }
                        }
                        if(user_data && user_data.branding_pref){
                            if(user_data.branding_pref.primary_color){
                                slide.primary_color = user_data.branding_pref.primary_color.replace('#', '');
                            }
                            if(user_data.branding_pref.secondary_color){
                                slide.secondary_color = user_data.branding_pref.secondary_color.replace('#', '');
                            }
                            if(user_data.branding_image){
                                slide.branding_image = user_data.branding_image;
                            }
                        }
                        try {
                            if(user_data && user_data.branding_pref){
                                slide.infobox_m = user_data.branding_pref.infobox_m ? user_data.branding_pref.infobox_m : false;
                                slide.infobox_s = user_data.branding_pref.infobox_s ? user_data.branding_pref.infobox_s : false;
                            }
                        } catch (e) {}
                        slides.push(slide);
                    }
                }
            }else{
                for(let i = 0; i < images.length; i++){
                    if(images[i].label && slides.length < 9){
                        let slide = {
                            image: "",
                            image_title: null,
                            title: "",
                            description: industry + " | " + location
                        };
                        for(let m = 0; m < items.length; m++){
                            if(!items[m].used && +items[m].label === +images[i].label.id && !slide.image_title){
                                slide.image_title = items[m].title;
                                items[m].used = true;
                                break;
                            }
                        }
                        if(!slide.image_title){
                            for(let m = 0; m < items.length; m++){
                                if(!items[m].used && (!items[m].label && items[m].label !== 0)){
                                    slide.image_title = items[m].title;
                                    items[m].used = true;
                                    break;
                                }
                            }
                        }
                        if(!slide.image_title){
                            slide.image_title = images[i].label.title;
                        }
                        slide.image = images[i].images.small;
                        slide.title = images[i].label.title;

                        if(user_data && user_data.branding_pref){
                            if(user_data.branding_pref.primary_color){
                                slide.primary_color = user_data.branding_pref.primary_color.replace('#', '');
                            }
                            if(user_data.branding_pref.secondary_color){
                                slide.secondary_color = user_data.branding_pref.secondary_color.replace('#', '');
                            }
                            if(user_data.branding_image){
                                slide.branding_image = user_data.branding_image;
                            }
                        }

                        try {
                            if(user_data && user_data.branding_pref){
                                slide.infobox_m = user_data.branding_pref.infobox_m ? user_data.branding_pref.infobox_m : false;
                                slide.infobox_s = user_data.branding_pref.infobox_s ? user_data.branding_pref.infobox_s : false;
                            }
                        } catch (e) {}

                        slides.push(slide);
                    }
                }
            }

            this.setState({
                items: slides,
                custom: custom_slides.length > 0
            })
        }
    };


    functions = {};

    render() {
        //let url = "http://localhost:3001/";
        let url = "https://preview." + dataRegister.domain + "/";
        if (collectedRegister.getValue("custom_creative")) {
            url = "https://coral-app-xg6gr.ondigitalocean.app/";
        }
        let frames = [];
        if(!this.state.custom){
            frames.push(
                <div className={Styles.containerInner}>
                    <iframe className={Styles.iframe} frameBorder={"none"} height={"100%"} width={"100%"} src={collectedRegister.getValue("custom_creative") ?
                        url + collectedRegister.getValue("reseller_name") + "/carousel/" + this.state.theme + "/first?" + this.state.query + "&legacy=false"
                        :
                        url + salesChannelRegister.get("name")+"/carousel/"+this.state.theme+"/first?" + this.state.query} allowFullScreen/>
                    <div className={Styles.containerInnerOverlay}/>
                </div>
            );
            this.state.items.map((item) => {
                frames.push(
                    <div className={Styles.containerInner}>
                        <iframe className={Styles.iframe} frameBorder={"none"} height={"100%"} width={"100%"} src={collectedRegister.getValue("custom_creative") ?
                            url + collectedRegister.getValue("reseller_name") + "/carousel/" + this.state.theme + "/center?image=" + item.image + "&title=" + item.image_title + "&legacy=false"
                            :
                            url + salesChannelRegister.get("name")+"/carousel/"+this.state.theme+"/center?image=" + item.image + "&title=" + item.image_title + (item.primary_color?("&primary_color=" + item.primary_color + "&secondary_color=" +item.secondary_color):"") + "&infobox_m=" + item.infobox_m + "&infobox_s=" +item.infobox_s} allowFullScreen/>
                        <div className={Styles.containerInnerOverlay}/>
                    </div>
                );
            });
            frames.push(
                <div className={Styles.containerInner}>
                    <iframe className={Styles.iframe} frameBorder={"none"} height={"100%"} width={"100%"} src={collectedRegister.getValue("custom_creative") ?
                        url + collectedRegister.getValue("reseller_name") + "/carousel/" + this.state.theme + "/last?" + this.state.query + "&legacy=false"
                        :
                        url + salesChannelRegister.get("name")+"/carousel/"+this.state.theme+"/last?" + this.state.query} allowFullScreen/>
                    <div className={Styles.containerInnerOverlay}/>
                </div>
            );
        }else{
            this.state.items.map((item) => {
                frames.push(
                    <div className={Styles.containerInner}>
                        <img style={{width: '100%'}} src={item.image}/>
                        <div className={Styles.containerInnerOverlay}/>
                    </div>
                );
            });
        }
        return (
            <div className={cx(Styles.container)}>
                <div className={Styles.containerInner}>
                    <Carousel interval={2000} loop auto widgets={[IndicatorDots]} frames={frames}/>
                </div>
            </div>
        );
    }
}

export default SignupAdsInstagramCarousel;


// WEBPACK FOOTER //
// ./src/components/signup-ads-instagram-carousel/component.js